<div class="wo-loading-bar">
  <div class="wo-loading-bar-value" *ngIf="loading"></div>
</div>
